import { ViewController, NavParams } from 'ionic-angular';
import { Component } from '@angular/core';

@Component({
  template: `
    <ion-list>
      <ion-item class="filterDropDown">
        <ion-label>{{ "allowRefund" | translate }}</ion-label>
        <ion-checkbox item-end color="themeBlue" [checked]="filter.isEnableAllowRefundFilter" (click)="updateOption(true, false, false)" mode="md"></ion-checkbox>
      </ion-item>
      <ion-item class="filterDropDown">
        <ion-label>{{ "priceLowerThan" | translate }}</ion-label>
        <ion-checkbox item-end color="themeBlue" [checked]="filter.isEnablePriceFilter" (click)="updateOption(false, true, false)" mode="md"></ion-checkbox>
      </ion-item>
      <ion-item class="filterDropDown" *ngIf="filter.isEnablePriceFilter">
        <ion-range min="0" max="500" step="10" pin="true" [(ngModel)]="filter.iPriceInFilter">
          <ion-icon small range-left name="logo-usd"></ion-icon>
          <ion-icon range-right name="logo-usd"></ion-icon>
        </ion-range>
      </ion-item>
      <ion-item class="filterDropDown">
        <ion-label>{{ "topTipsters" | translate }}</ion-label>
        <ion-checkbox item-end color="themeBlue" [checked]="filter.isEnableRankingFilter" (click)="updateOption(false, false, true)" mode="md"></ion-checkbox>
      </ion-item>
    </ion-list>
  `
})
export class ListTipsPopoverPage {
  filter: Filter;

  constructor(public viewCtrl: ViewController, private navParams: NavParams) {
  }

  ngOnInit() {
    this.filter = this.navParams.get('filter');
  }

  updateOption(isEnableAllowRefundFilter: boolean, isEnablePriceFilter: boolean, isEnableRankingFilter: boolean) {
    if (isEnableAllowRefundFilter) {
      this.filter.isEnableAllowRefundFilter = !this.filter.isEnableAllowRefundFilter;
    } else if (isEnablePriceFilter) {
      this.filter.isEnablePriceFilter = !this.filter.isEnablePriceFilter;
    } else if (isEnableRankingFilter) {
      this.filter.isEnableRankingFilter = !this.filter.isEnableRankingFilter;
    }
    this.navParams.get('updateFilterClicked')();
    // Close the popover
    //this.close();
  }

  close() {
    this.viewCtrl.dismiss(this.filter);
  }
}

export class Filter {
  isEnableAllowRefundFilter: boolean;
  isEnablePriceFilter: boolean;
  iPriceInFilter: number;
  isEnableRankingFilter: boolean;
  iRankingInFilter: number;

  constructor(isEnableAllowRefundFilter : boolean, isEnablePriceFilter: boolean, iPriceInFilter: number, isEnableRankingFilter: boolean,
      iRankingInFilter: number) {
    this.isEnableAllowRefundFilter = isEnableAllowRefundFilter;
    this.isEnablePriceFilter = isEnablePriceFilter;
    this.iPriceInFilter = iPriceInFilter;
    this.isEnableRankingFilter = isEnableRankingFilter;
    this.iRankingInFilter = iRankingInFilter;
  }

  isEnabled(): boolean {
    return this.isEnableAllowRefundFilter || this.isEnablePriceFilter || this.isEnableRankingFilter;
  }

  reset(iPriceInFilter, iRankingInFilter) {
    this.isEnableAllowRefundFilter = false;
    this.isEnablePriceFilter = false;
    this.iPriceInFilter = iPriceInFilter;
    this.isEnableRankingFilter = false;
    this.iRankingInFilter = iRankingInFilter;
  }
}



// WEBPACK FOOTER //
// ./src/pages/horse/horse-home-list-tips/filter.ts